<div class="spinner-overlay">
  <div class="spinner-container">
    @if (failed) {
      <!-- B7: the post-login work failed. Same copy, same amber treatment and
           same Retry as every other wait in the app. -->
      <div class="spinner-failed">
        <div class="failed-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M12 9v4"></path>
            <path d="M12 17h.01"></path>
            <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
          </svg>
        </div>
        <h2>{{ 'loader.failed.heading' | translate }}</h2>
        <p>{{ 'loader.failed.body' | translate }}</p>
        <button type="button" class="spinner-retry" (click)="retry()">{{ 'loader.failed.retry' | translate }}</button>
        <div class="spinner-support">{{ 'loader.failed.support' | translate }}</div>
      </div>
    } @else {
      <div class="spinner">
        <div class="spinner-ring"></div>
        <div class="spinner-ring"></div>
        <div class="spinner-ring"></div>
        <div class="spinner-ring"></div>
      </div>
      <div class="spinner-text">
        <h2>{{ 'spinner.settingUpAccountTitle' | translate }}</h2>
        <p>{{ 'spinner.settingUpAccountSubtitle' | translate }}</p>
        <!-- B7 DELAYED: past the expected wait, say it is slow and that nothing is lost. -->
        @if (delayed) {
          <div class="spinner-delayed">{{ 'loader.delayedNote' | translate }}</div>
        }
      </div>
    }
  </div>
</div>
